import React, { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import { Button, Grid, Link, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import useLocalStorage from "react-use/lib/useLocalStorage";

import { useHistory } from "react-router";

import { useAlert } from "react-alert";

import useOptIntoEventLibrary from "../mutations/useOptIntoEventLibrary";
import useFeatureFlags from "../../hooks/useFeatureFlag";
import useOptInEventEmitter from "../instrumentation/useOptInEventEmitter";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiAlert-message": {
      width: "100%",
    },
  },
}));

const LEGACY_EVENTS_SUNSET_BANNER_DISMISSED_KEY =
  "__legacyEventsSunsetBannerDismissed";

function LegacyEventsSunsetBanner() {
  const alert = useAlert();
  const classes = useStyles();
  const flags = useFeatureFlags();
  const history = useHistory();
  const eventEmitter = useOptInEventEmitter();
  const [componentRenderTracked, setComponentRenderTracked] = useState<boolean>(
    false
  );

  const [isDismissed, setIsDismissed] = useLocalStorage(
    LEGACY_EVENTS_SUNSET_BANNER_DISMISSED_KEY,
    false
  );

  const { mutate: optIn, isLoading: isOptingIn } = useOptIntoEventLibrary(
    () => {
      alert.success("Redirecting to the new event library...");

      setTimeout(() => {
        history.push("/events/library");
      }, 1000);
    },
    () => {
      alert.error(
        "Failed to opt in. Please try again or contact support for assistance."
      );
    }
  );

  useEffect(() => {
    // Only track the first render, and ignore cases where we would not show the banner's contents.
    if (
      componentRenderTracked ||
      isDismissed ||
      flags("displayNewEventLibraryPage")
    ) {
      return;
    }

    void eventEmitter.trackBannerViewed();
    setComponentRenderTracked(true);
  }, [
    componentRenderTracked,
    eventEmitter,
    flags,
    isDismissed,
    setComponentRenderTracked,
  ]);

  if (isDismissed || flags("displayNewEventLibraryPage")) {
    return null;
  }

  return (
    <>
      <Alert
        className={classes.root}
        severity="info"
        icon={<span style={{ marginTop: 6 }}>🎉</span>}
        style={{ borderBottom: "1px solid #ccc", borderRadius: 0 }}
      >
        <Grid container spacing={2}>
          <Grid item xs={9}>
            <Typography variant="h4">
              A New Event Library is Coming Soon!
            </Typography>
            <Typography variant="body1">
              Our new and improved Event Library will replace this page on June
              1, 2024. If you'd like to try it out right away, click the{" "}
              <strong>try it now</strong> button.
            </Typography>
            <Typography variant="body1">
              Learn more about the new Event Library{" "}
              <Link
                href="https://documentation.freshpaint.io/admin-panel/events/event-library-2.0-new"
                target="_blank"
              >
                in Freshpaint's documentation
              </Link>
              .
            </Typography>
          </Grid>

          <Grid item xs={3} style={{ textAlign: "right" }}>
            <Button
              color="secondary"
              disabled={isOptingIn}
              variant="outlined"
              onClick={() => {
                if (isOptingIn) {
                  return;
                }

                void eventEmitter.trackBannerDismissed();

                setIsDismissed(true);
              }}
            >
              Dismiss
            </Button>

            <Button
              color="secondary"
              disabled={isOptingIn}
              onClick={() => {
                if (isOptingIn) {
                  return;
                }

                void eventEmitter.trackOptInNowClicked();

                optIn();
              }}
              variant="contained"
              style={{ marginLeft: "1em" }}
            >
              {isOptingIn ? "Opting In..." : "Try It Now"}
            </Button>
          </Grid>
        </Grid>
      </Alert>
    </>
  );
}

export default LegacyEventsSunsetBanner;
